export default __webpack_public_path__ + "static/media/Circly_List_Insertion_2.f7ca3232.gif";